<template>
	<div class="myspace"
	     :class="{'companion-reached-final' : !isHeadingTextVisible}">
		<div class="myspace__header"
		     ref="headerRef">
			<div class="myspace__welcoming-part"
			     ref="welcomingPartRef">
				<div class="myspace__companion-memoji">
					<SidebarCompanion :defaultProps="defaultHeadingProps"
					                  :routeProps="routeProps"
					                  :isHeadingVisible.sync="isHeadingTextVisible"
					                  :toFinalPosition="toFinalPosition" />
				</div>
			</div>
		</div>
		<div class="myspace__page-content-wrapper">
			<div class="sidebar-companion-faker"
			     ref="companionMemojiRef"
			     v-if="isMobile"
			     style="width: 100%; height: 80rem; opacity: 0;"></div>
			<div ref="headingTextRef"
			     class="myspace__heading-text">
				<p>
					My name is Altin Selimi.
					I’ve been making stuff with <span class="linky">web technologies</span> for the past 7 years.
					Other than web, I also have a soft spot for good design.
					I love outdoors, football and movies.
					Currently looking for my next adventure. Let’s make something great together !
				</p>
				<a href="https://github.com/altinselimi"
				   target="_blank"
				   class="social-media-link">
					<GithubIcon />
				</a>
				<a href="https://twitter.com/altinselimi"
				   target="_blank"
				   class="social-media-link">
					<TwitterIcon />
				</a>
				<a href="https://instagram.com/altinselimi"
				   target="_blank"
				   class="social-media-link">
					<InstagramIcon />
				</a>
			</div>
			<div class="myspace__page-content"
			     ref="contentRef">
				<div class="spacer"
				     :style="`flex-basis: ${toFinalPosition > 0 ? toFinalPosition * 100 : 0}px`"></div>
				<div style="width: 100%;" class="contentScrollTarget">
					<div class="myspace__menu"
					     :class="{'sticked': menuSticked}"
					     ref="menuRef">
						<div class="link-wrapper"
						     v-for="page in pages">
							<router-link :to="page.path">
								{{page.name}}
								<WavyLine class="wavy-line" />
							</router-link>
						</div>
					</div>
					<div class="myspace__content">
						<slot></slot>
					</div>
				</div>
			</div>
		</div>
		<footer style="margin: 20px 0px;">
			🇽🇰 Copyright © Altin Selimi 2019 - forever 🇽🇰
		</footer>
	</div>
</template>
<script>
import SidebarCompanion from '@/components/SidebarCompanion.vue';
import { pages } from '@/router';
import GithubIcon from '@/assets/github.vue';
import TwitterIcon from '@/assets/twitter.vue';
import InstagramIcon from '@/assets/instagram.vue';
import WavyLine from '@/assets/wavy-line.vue';

const hour = new Date().getHours();
const dynamicHello = hour < 12 ? 'morning' : hour < 18 ? 'afternoon' : 'evening';

export default {
	components: {
		SidebarCompanion,
		GithubIcon,
		TwitterIcon,
		InstagramIcon,
		WavyLine
	},
	mounted() {

		const headingText = this.$refs.headingTextRef;

		let observer = new IntersectionObserver(entries => {
			let entry = entries[0];
			let { intersectionRatio: iR } = entry;
			if (iR > 0) {
				this.isHeadingTextVisible = true;
			} else {
				this.isHeadingTextVisible = false;
			}
		});

		observer.observe(headingText);
	},
	created() {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	computed: {
		menuSticked() {
			return !this.isHeadingTextVisible;
		},
		isMobile() {
			return window.outerWidth <= 550;
		},
		routeProps() {
			return this.$route.meta;
		},
		defaultHeadingProps() {
			return {
				memoji: require(`../assets/hello.png`),
				corner_text: `Good ${dynamicHello},\nrandom citizen.\n`,
			}
		},
		pages() {
			return pages.filter(p => !p.hasOwnProperty('redirect'))
		},
	},
	data: () => ({
		toFinalPosition: 0,
		isHeadingTextVisible: true,
		clicked: false,
	}),
	methods: {
		handleScroll(...params) {
			// setTimeout(() => {
				let targetRef = 'headingTextRef';
				if (window.outerWidth <= 550) targetRef = 'companionMemojiRef';
				let scrollTarget = this.$refs[targetRef].getBoundingClientRect();
				this.toFinalPosition = this.getFinalPositionPercentage(scrollTarget.height, scrollTarget.top);
			// })
		},
		isInTheViewport(domElement) {
			var bounding = domElement.getBoundingClientRect();
			return bounding.height - (-1 * bounding.top) > 0;
		},
		getFinalPositionPercentage(elementHeight, topPosition) {
			if ((-1 * topPosition) > elementHeight) topPosition = (-1 * elementHeight);
			let result = (elementHeight - (-1 * topPosition)) / elementHeight;
			result = (result - 1) * -1;
			return result >= 0 ? result : 0;
		},
	}
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=PT+Serif:400,700&display=swap');

:root {
	--max-heading-text-size: 28px;
	--max-content-text-size: 20px;
	--max-content-title-size: 32px;

}


.myspace {
	width: 100%;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: white;

	&__header {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		width: 100%;
		max-width: var(--max-app-width);
	}

	&__heading-text {

		margin-left: calc(100%/3);
		line-height: 2.5rem;
		margin-bottom: 4rem;
		align-self: flex-end;
		padding: 20px;
		padding-top: 6rem;

		p {
			font-style: normal;
			font-weight: normal;
			font-size: 2rem;
			margin-bottom: 4rem;
		}

		@media screen and (min-width: 1200px) {
			margin-bottom: 60px;
			padding-top: 60px;

			p {
				font-size: 22px;
			}
		}

		@media screen and (max-width: 700px) {
			margin-left: calc((100% / 3) + 10px);

			p {
				font-size: 2.5rem;
				line-height: 1.2;
				margin-right: 2rem;
			}
		}

		@media screen and (max-width: 550px) {
			margin: 0px 20px;
			margin-bottom: 2.5rem;

			p {
				font-size: 5.2rem;
				line-height: 1.4;
			}
		}
	}

	&__page-content-wrapper {
		max-width: var(--max-content-width);
		display: flex;
		flex-direction: column;
	}

	&__page-content {
		margin-left: auto;
		padding-left: 40px;
		padding: 0px 10px;
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		margin-bottom: 1vw;
		width: 100%;

		@media screen and (max-width: 950px) {
			padding: 0px 10rem;
			padding-right: 5rem;
		}

		@media screen and (max-width: 750px) {
			padding: 0px 15rem;
			padding-right: 5rem;
		}

		@media screen and (max-width: 550px) {
			padding: 0px 20px;

			.spacer {
				flex-basis: 0px !important;
			}
		}

	}
}

.myspace__menu {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-left: auto;
	position: sticky;
	backdrop-filter: blur(15px);
	top: 0;
	background-color: rgba(white, .8);
	padding: 0px 5px;
	padding-bottom: 2px;
	width: calc(100% + 40px);
	margin-left: -20px;
	transform: translateZ(0);
	z-index: 5;

	>div {
		display: inline-flex;
		align-items: flex-end;
		justify-content: center;
		position: relative;

		&:first-child {
			margin-left: 20px;
		}

		&:last-child {
			margin-right: 20px;
		}

	}

	a {
		line-height: calc(3.8rem + 30px);
		transition: all .2s;
		cursor: pointer;
		font-size: 2rem;
		font-weight: 300;
		text-decoration: none;
		color: var(--dark-shade);
		text-transform: capitalize;
		position: relative;

		&.router-link-active {
			font-weight: 900;
			font-size: 3.8rem;
			will-change: transform;

			.wavy-line {
				display: block;
			}
		}

		@media screen and (min-width: 1200px) {
			line-height: calc(3rem + 30px);

			&.router-link-active {
				font-weight: 900;
				font-size: 3rem;
			}
		}
	}

	&.sticked {
		box-shadow: 0px 6px 5px -8px rgba(black, .3);
		z-index: 20;

		a.router-link-active {
			font-size: 2.8rem;
		}

		.wavy-line {
			bottom: 5px;
		}
	}

	@media screen and (max-width: 550px) {
		top: 23.5rem;

		a {
			font-size: 4rem;
			line-height: calc(6rem + 30px);

			&.router-link-active {
				font-size: 6rem;
			}
		}

		&.sticked a.router-link-active {
			font-size: 6rem;
		}

	}
}

.social-media-link {
	svg {
		width: 20px;
		margin-right: 10px;
		stroke: darken(#fbfbfb, 40);

		&:hover,
		&:focus {
			stroke: var(--dark-shade);
		}
	}
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-family: 'PT Serif', serif;
	color: var(--dark-shade);
}

p {
	color: var(--dark-shade);
}

.wavy-line {
	width: 6vw;
	min-width: 20px;
	max-width: 100px;
	position: absolute;
	bottom: 0;
	left: 0;
	display: none;

	@media screen and (max-width: 550px) {
		width: 15vw;
		bottom: 0 !important;
	}
}
</style>
